exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.button_full[data-v-2aa0f230] {\n    margin-top: 20px\n}\nselect[data-v-2aa0f230] {\n    width: 100%;\n    height: 35px;\n    font-size: 18px;\n    padding-left: 5px;\n}\nh5[data-v-2aa0f230] {\n    font-weight: bold;\n    padding: 10px 0 10px 0;\n}\n.loader[data-v-2aa0f230] {\n    position: absolute;\n}\n.table_section_brochure[data-v-2aa0f230]{\n    width:55%\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2aa0f230","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./scripts/src/pages/brochures.vue
// module id = 585
// module chunks = 0